import {NgModule} from '@angular/core';
import {ExtendedTimeAgoPipe} from './extended-time-ago.pipe';

@NgModule({
  declarations: [ExtendedTimeAgoPipe],
  exports: [ExtendedTimeAgoPipe],
})
export class ExtendedTimeAgoModule {}
